export default __webpack_public_path__ + "static/media/hardDrop.d2d4cb32.mp3";